export default "__VITE_ASSET__bqMv7UoW__"